import { api } from './api';
import config from 'config';
import { hasValue } from 'swipeclock-frontend';

export const companyMessagesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyMessages: build.query({
      query: () => ({
        url: `${config.mdsApiUrl}/api/company/message`,
        method: 'GET',
      }),
      transformResponse: (res) => {
        if (hasValue(res)) {
          return res;
        }

        return [];
      },
      providesTags: () => {
        return [{ type: 'hub', id: `COMPANY_MESSAGES` }];
      },
    }),
  }),
});

export const { useGetCompanyMessagesQuery } = companyMessagesApi;
